import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Adaptive accreditation visual (no frame — just the image):
//   - exactly 1 image  → one large image
//   - more than 1 image → autoplaying carousel
export default function AccreditationShowcase({
  images,
  maxWidth = 280,
}: {
  images: string[];
  maxWidth?: number;
}) {
  if (!images || images.length === 0) return null;

  const imgStyle = { width: '100%', maxWidth: `${maxWidth}px`, height: 'auto' as const };

  if (images.length === 1) {
    return (
      <div className="accreditation-showcase accreditation-showcase--single">
        <img src={images[0]} alt="Accreditation" style={imgStyle} />
      </div>
    );
  }

  return (
    <div className="accreditation-showcase accreditation-showcase--slider">
      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        loop
        autoplay={{ delay: 3000, disableOnInteraction: false }}
      >
        {images.map((src, i) => (
          <SwiperSlide key={i}>
            <div className="accreditation-showcase-slide">
              <img src={src} alt={`Accreditation ${i + 1}`} style={imgStyle} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
